// Shared theme tokens, extracted out of App.tsx so other views (e.g.
// BacktestView) can reuse the same dark, trading-aesthetic palette instead
// of duplicating it. Plain constants instead of Tailwind -- this project
// has no Tailwind/PostCSS setup; adding one just for a color pass would be
// a much bigger change than what was asked.
export const colors = {
  bg: '#0b0f17',
  panel: '#111827',
  panelAlt: '#0f1522',
  border: '#1f2937',
  text: '#e5e7eb',
  textDim: '#9ca3af',
  textFaint: '#6b7280',
  accent: '#60a5fa',
  long: '#34d399',
  short: '#f87171',
  danger: '#f87171',
  dangerBg: '#3b1219',
};

export const mono = '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace';
export const sans = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

export function statusStyle(status: string): { bg: string; color: string } {
  switch (status) {
    case 'active':
      return { bg: '#1e3a5f', color: '#7dd3fc' };
    case 'tp1_hit':
    case 'tp2_hit':
      return { bg: '#14352a', color: colors.long };
    case 'sl_hit':
      return { bg: colors.dangerBg, color: colors.short };
    case 'expired':
    case 'invalidated':
      return { bg: '#3a2a12', color: '#fbbf24' };
    case 'watchlist':
    default:
      return { bg: '#1f2937', color: colors.textDim };
  }
}

export const thStyle: React.CSSProperties = {
  padding: '10px 14px', textAlign: 'left', color: colors.textDim,
  fontFamily: sans, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: 600,
};

export const tdStyle: React.CSSProperties = {
  padding: '10px 14px', color: colors.text,
};
